export default __webpack_public_path__ + "static/prod7-1435d7ed9305f10f059fe6f04adeb4ef.jpg";